<svelte:head>
  <head>
    <title>Fast Attack Leadership Readiness Report</title>
    <meta name="viewport" content="width=device-width,initial-scale=1" />
  </head>
</svelte:head>
<div class="bg-white lg:rounded-2xl {$$props.class}">
  <div class="px-8">
    <slot />
  </div>
</div>
